import { createFileRoute } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { MillsheetHomeContainer } from '@/components/screens/millsheet/millsheet-home-container'

export const Route = createFileRoute('/t/$tenant_id/')({
  component: MillsheetHomePage,
})

// route はレイアウト（サイドバー + メイン領域）だけを組み、データ取得・ミューテーション配線は
// MillsheetHomeContainer（components/screens/millsheet/）に委譲する
function MillsheetHomePage() {
  const { tenant_id: tenantId } = Route.useParams()
  return (
    <div className="flex min-h-screen">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1">
        <MillsheetHomeContainer tenantId={tenantId} />
      </main>
    </div>
  )
}
